export default "__VITE_ASSET__tYW_i1d6__";